import { hexToRgb, whiteColor } from '../../jss/material-dashboard-pro-react'

const cardBodyStyle = {
  cardBody: {
    padding: 'var(--sp-5, 20px) var(--sp-6, 24px)',
    flex: '1 1 auto',
    WebkitBoxFlex: '1',
    position: 'relative',
  },
  cardBodyBackground: {
    position: 'relative',
    zIndex: '2',
    minHeight: '280px',
    paddingTop: 'var(--sp-10, 40px)',
    paddingBottom: 'var(--sp-10, 40px)',
    maxWidth: '440px',
    margin: '0 auto',
  },
  cardBodyPlain: {
    paddingLeft: 'var(--sp-1, 4px)',
    paddingRight: 'var(--sp-1, 4px)',
  },
  cardBodyFormHorizontal: {
    paddingLeft: 'var(--sp-4, 16px)',
    paddingRight: 'var(--sp-4, 16px)',
    '& form': {
      margin: '0',
    },
  },
  cardPricing: {
    padding: 'var(--sp-4, 16px)!important',
    margin: '0px!important',
  },
  cardSignup: {
    padding: '0px var(--sp-8, 32px) 0px var(--sp-8, 32px)',
  },
  cardBodyColor: {
    borderRadius: '6px',
    '& h1,& h2,& h3': {
      '& small': {
        color: 'rgba(' + hexToRgb(whiteColor) + ', 0.8)',
      },
    },
  },
  cardBodyProfile: {
    marginTop: '15px',
  },
  cardBodyCalendar: {
    padding: '0px !important',
  },
}

export default cardBodyStyle
